var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7746 7.2278C16.6945 7.27791 14.7893 8.33531 14.7893 10.6798C14.8791 13.3536 17.1936 14.2912 17.2333 14.2912C17.1936 14.3413 16.8839 15.5686 15.9664 16.855C15.2382 17.9632 14.4301 19.0804 13.2028 19.0804C12.0355 19.0804 11.6164 18.3419 10.2694 18.3419C8.82292 18.3419 8.41362 19.0804 7.30612 19.0804C6.07889 19.0804 5.21084 17.9033 4.44301 16.8056C3.44547 15.3688 2.5976 13.1141 2.56767 10.9492C2.5475 9.802 2.76744 8.67433 3.32574 7.71649C4.11375 6.37928 5.52058 5.47155 7.0569 5.44161C8.23403 5.40192 9.28167 6.24979 10 6.24979C10.6885 6.24979 11.9756 5.44161 13.4319 5.44161C14.0605 5.44226 15.7367 5.63162 16.7746 7.2278ZM9.90049 5.21256C9.69096 4.16493 10.2694 3.11729 10.8082 2.44901C11.4967 1.64083 12.584 1.09229 13.5217 1.09229C13.5815 2.13992 13.2022 3.16739 12.5241 3.9157C11.9157 4.72388 10.8681 5.33229 9.90049 5.21256Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.bd54da2ea7f614a7c4c0cf57f20eba52.svg";
export { ForwardRef as ReactComponent };